export function setLocalStorageItem(key, value){
    try{
        localStorage.setItem(key, value);
    }catch(error){
        // Do nothing
        // Access is denied by browser configs
    }
}

export function getLocalStorageItem(key){
    try{
        return localStorage.getItem(key);
    }catch(error){
        // Do nothing
        // Access is denied by browser configs
    }
}

export function removeLocalStorageItem(key){
    try{
        return localStorage.removeItem(key);
    }catch(error){
        // Do nothing
        // Access is denied by browser configs
    }
}

export function clearLocalStorage(){
    try{
        return localStorage.clear();
    }catch(error){
        // Do nothing
        // Access is denied by browser configs
    }
}